<template>
  <div class="print-selfevaluation">
    <el-row class="print-declarationInfo__control" type="flex" justify="end">
      <el-button style="margin-right: 20px;" type="primary" @click="handlePrint">打印</el-button>
    </el-row>
    <div class="print-fabricQuoted__box">
      <selfevaluation-check :in-print="inPrint" ref="selfevaluationCheck">
        <div slot="title" class="print-selfevaluation__title">面料自评表</div>
      </selfevaluation-check>
    </div>
  </div>
</template>

<script>
import selfevaluationCheck from "./detail.vue";
import { createIframePrint } from "src/common/print";

export default {
  name: "print-selfevaluation",
  components: {
    selfevaluationCheck
  },
  computed: {},
  data() {
    return {
      inPrint: false
    };
  },
  methods: {
    handlePrint() {
      const ele = document.querySelector(".print-fabricQuoted__box");
      this.inPrint = true;
      setTimeout(() => {
        createIframePrint(ele).then(() => {
          this.inPrint = false;
        });
      }, 1000);
    }
  }
};
</script>

<style lang="scss">
@import "src/sass/index";
.print-selfevaluation {
  position: fixed;
		overflow-y: scroll;
		height: 100vh;
    width: 100%;
  .print-selfevaluation__title {
    font-size: 24px;
    text-align: center;
    margin-bottom: 30px;
  }
  * {
    font-size: 20px;
  }
  tr {
    td {
      div {
        white-space: normal !important;
      }
    }
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    width: 18px;
    height: 20px;
    background-color: #DCDFE6;
  }
  .el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #666;
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    position: absolute;
    content: "";
    top: 1px;
    left: 3px;
    width: 7px;
    height: 6px;
    transform: rotate(
    45deg
    );
    background-color: #DCDFE6;
    border-color: #DCDFE6;
    z-index: 1;
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::before {
    position: absolute;
    content: "";
    top: 2px;
    left: 2px;
    width: 12px;
    height: 12px;
    transform: rotate(45deg);
    background-color: #fff;
    border: none;
    z-index: 1;
  }
}
</style>

